import { withRipple } from '../hocs/withRipple/index.js';
import darkTheme from '../theme/darkBaseTheme.js';
import * as React from 'react';
import { useContext, Fragment } from 'react';
import { ThemeContext } from 'styled-components';
import { Circle } from './Circle.js';
import { Container } from './Container.js';
import { Content, Title, Description, RightContent, AdditionalButton, ArrowRightIcon, Delimiter, RippleContainer } from './styles.js';

const RippleEffect = withRipple(RippleContainer);
const Action = ({ href , target , className , onClick , title , description , withDelimiter =false , icon , disabled =false , textColor , descriptionColor , circleBorderColor , circleColor , hasAdditionalButton , additionalButtonText , hasCircleBadge , circleBadgeColor , circleBadgeBorderColor , circleBadgeIcon , circleBadgeText , circleBadgeTextColor , additionalButtonNoWrap =false , iconVariant ="rounded"  })=>{
    const theme = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(Container, {
        className: className,
        href: href,
        onClick: onClick,
        disabled: disabled,
        target: target,
        testId: "action"
    }, /*#__PURE__*/ React.createElement(Content, {
        isTransparent: disabled,
        hasDescription: Boolean(description),
        hasDelimiter: Boolean(withDelimiter),
        "data-testid": "action-content"
    }, /*#__PURE__*/ React.createElement(Circle, {
        icon: icon,
        borderColor: circleBorderColor,
        color: circleColor,
        hasBadge: hasCircleBadge,
        badgeColor: circleBadgeColor,
        badgeBorderColor: circleBadgeBorderColor,
        badgeIcon: circleBadgeIcon,
        badgeText: circleBadgeText,
        badgeTextColor: circleBadgeTextColor,
        testId: "action",
        variant: iconVariant
    }), /*#__PURE__*/ React.createElement(Title, {
        "data-testid": "action-title",
        color: textColor
    }, title), description && /*#__PURE__*/ React.createElement(Description, {
        "data-testid": "action-description",
        color: descriptionColor
    }, description), additionalButtonNoWrap ? /*#__PURE__*/ React.createElement(RightContent, {
        "data-testid": "action-additional-button-text"
    }, additionalButtonText) : /*#__PURE__*/ React.createElement(Fragment, null, hasAdditionalButton ? /*#__PURE__*/ React.createElement(AdditionalButton, {
        small: true,
        outlined: true,
        color: theme.colors.secondary,
        borderColor: theme.colors.secondaryBackground,
        isDisabled: disabled,
        rippleColor: darkTheme.colors["Level 2"],
        "data-testid": "action-additional-button"
    }, additionalButtonText) : /*#__PURE__*/ React.createElement(ArrowRightIcon, {
        color: theme.colors["Level 3"]
    })), withDelimiter && /*#__PURE__*/ React.createElement(Delimiter, null), !disabled && /*#__PURE__*/ React.createElement(RippleEffect, null)));
};

export { Action };
